import { useMemo, useState } from 'react';
import { message } from 'antd';
import { useMutation } from '@apollo/client';
import { SEARCH_INDEX_DELAY } from '../../consts';
import DELETE_NOTIFICATION_MUTATION from '../mutations/DELETE_NOTIFICATION_MUTATION';
  
const useDeleteNotification = () => {
    const [ isDeleting, setIsDeleting ] = useState( false );
    const [ deleteMutation ] = useMutation( DELETE_NOTIFICATION_MUTATION );

    const handleDeleteNotification = async ( id, onFinishCallback ) => {
        setIsDeleting( true );
        
        try {
            await deleteMutation( { variables: { input: { id: id } } } );
            
            setTimeout( () => {
                if ( onFinishCallback ) { onFinishCallback(); }
                setIsDeleting( false );
            }, SEARCH_INDEX_DELAY );
        } catch ( e ) { 
            console.error( e ); 
            message.error( 'Error deleting notification!' );
            setIsDeleting( false );
        }
    };

    return useMemo( () => {
        return {
            isDeleting,
            deleteNotification: handleDeleteNotification
        };
    }, [ isDeleting ] );
};

export default useDeleteNotification;
